import pegasus from "../../assets/scripts/global/01-pegasus";

document.addEventListener("alpine:init", () => {
    Alpine.data("navigation", () => ({
        scrolled: false,
        anyNavOpen: false,
        menuOpen: false,
        megaMenuOpen: null,
        searchOpen: false,
        ctaOpen: false,
        mobMenuOpen: false,
        mobSubMenu: null,
        hasTransparentBg: false,
        isMobile: true,
        megaMenuTimeout: null,
        init() {

            window.addEventListener("opencallback", () => this.openCta());

            this.hasTransparentBg = this.$refs.navBar.classList.contains(
                "bg-navbar-transparent"
            );

            pegasus.onResizeFinished(() => {
                this.isMobile = window.outerWidth <= 992;

                const page = document.getElementById("content");

                if (this.hasTransparentBg === false) {
                    if (this.isMobile) {
                        page.style.paddingTop = "81px";
                    } else {
                        page.style.paddingTop = "90px";
                    }
                }
            }, true);
        },
        openSearch() {
            this.closeAll();
            this.navZedTop();
            this.anyNavOpen = true;
            this.searchOpen = true;
            this.lockScroll();
        },
        openCta() {
            this.closeAll();
            this.navZedTop();
            this.anyNavOpen = true;
            this.ctaOpen = true;
            this.lockScroll();
        },
        openMobNav() {
            this.closeAll();
            this.navZedTop();
            this.anyNavOpen = true;
            this.mobMenuOpen = true;
            this.lockScroll();
        },
        openNav() {
            this.closeAll();
            this.navZedTop();
            this.anyNavOpen = true;
            this.menuOpen = true;
            this.lockScroll();
        },
        closeAll() {
            document
                .getElementById("page-header")
                .style.removeProperty("z-index");
            this.anyNavOpen = false;
            this.menuOpen = false;
            this.megaMenuOpen = null;
            this.searchOpen = false;
            this.ctaOpen = false;
            this.mobMenuOpen = false;
            this.mobSubMenu = null;
            this.unlockScroll();
        },
        navZedTop() {
            document.getElementById("page-header").style.zIndex = "9999";
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        },
        menuScrolling() {
            const navigationContainer =
                    document.getElementById("page-nav-container"),
                navigationHeight = navigationContainer.offsetHeight;

            this.scrolled = window.scrollY >= navigationHeight;

            this.hasTransparentBg = this.$refs.navBar.classList.contains(
                "bg-navbar-transparent"
            );
        },
    }));
});
